<template>
<router-view></router-view>
</template>
<script>
export default {
}
</script>


// WEBPACK FOOTER //
// Root.vue?8ce48ea0